// eslint-disable-next-line prettier/prettier
import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';

// eslint-disable-next-line prettier/prettier
import {Container, PageTitle} from 'components';

import './ContactUsEn.scss';

const ContactUsEn: FC = () => {
  const {t} = useTranslation('about');

  return (
    <>
      <PageTitle title={t('contact.pageTitle')} canonicalUrl="https://www.xiangjifanyi.com/home/contact" />
      <Container className="TermsOfUse" maxWidth={720}>
        {/* <h1 className="TermsOfUse__heading">Contact us</h1>
      <div className="TermsOfUse__main-text" />
      <section className="TermsOfUse__section">
        <p className="TermsOfUse__text">You Can Also Contact Us Here:</p>
        <p className="TermsOfUse__text">Company: Suzhou XiangJi Technology Service Co. Ltd</p>
        <p className="TermsOfUse__text">
          Address: Room 102, Building 3, Taihu New City Science and Technology Park, No. 18 Suzhou River Road, East
          Taihu Lake Ecotourism Resort (Taihu New City), Wujiang District, Suzhou City, Jiangsu Province, P.R.C.
        </p>
        <p className="TermsOfUse__text">Customer Service (8AM - 6PM CST, 7 days a week):</p>
        <p className="TermsOfUse__text">phone number: +8617664075341</p>
        <p className="TermsOfUse__text">support email: bussiness@tosoiot.com</p>
      </section> */}
        <h1 className="TermsOfUse__heading">{t('contact.heading')}</h1>
        <div className="TermsOfUse__main-text" />
        <section className="TermsOfUse__section">
          <p className="TermsOfUse__text">{t('contact.companyName')}</p>
          <p className="TermsOfUse__text">{t('contact.addressSuzhou')}</p>
          <p className="TermsOfUse__text">{t('contact.addressShanghai')}</p>
          <p className="TermsOfUse__text">{t('contact.hours')}</p>
          <p className="TermsOfUse__text">{t('contact.phone')}</p>
          <p className="TermsOfUse__text">{t('contact.email')}</p>
        </section>
      </Container>
    </>
  );
};

export default ContactUsEn;
